import { useContext, useEffect, useRef } from 'react';
import { useForm } from 'react-final-form';
import ListingFieldsRequiredVisibleInfoContext from '../providers/ListingFieldsRequiredVisibleInfo/ListingFieldsRequiredVisibleInfo.context';
import {
  getIsDefaultRequired,
  ListingFieldBaseName,
} from 'router/data/defaultRequired';
import { REQUIRED_VISIBLE_INFO } from 'data/global';

export default function useListingFieldIsRequired(
  fieldName: ListingFieldBaseName,
  isUrgent = false,
) {
  const { fields } = useContext(ListingFieldsRequiredVisibleInfoContext);

  const key = `${fieldName}${REQUIRED_VISIBLE_INFO}` as const;

  const isDefaultRequired = getIsDefaultRequired(fieldName, isUrgent);

  const isRequired = fields?.[key]?.isRequired ?? isDefaultRequired;

  const form = useForm();

  const prevIsRequired = useRef(isRequired);

  useEffect(() => {
    if (prevIsRequired.current === isRequired) return;
    prevIsRequired.current = isRequired;

    // react-final-form wraps `validate` in a stable callback, so changing it
    // doesn't auto-revalidate. `resetFieldState` clears the stale touched/error
    // state and re-runs validation with the current validator chain.
    form.resetFieldState(fieldName);
  }, [isRequired, form, fieldName]);

  return [isRequired, isDefaultRequired];
}
